<template>
    <div class="container">
        <div class="content-wrapper">
            <slot />
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .container {
        max-width: $max-width;
        margin: $spacing--4 auto;
        padding-inline: $spacing;

        @media (min-width: calc($max-width + $spacing)) {
            padding: 0;
        }
    }

    .content-wrapper {
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        gap: $spacing;
    }
</style>
